// extracted by mini-css-extract-plugin
export default {"footerBg":"U-z","footerTopLinks":"V-z","footerFeedback":"W-z","footerSocial":"X-z","footerLegalLinks":"Y-z","footerIconCards":"Z-z","footerBotCopy":"_-z"};